import { caseOrange, ilIcon, infoIcon, prize, walletBlue } from '../../../assets';
import { useTranslation } from 'react-i18next';
import { RefBonusItemEntity } from '../Components/RefBonusItem/types';
import RefBonusItem from '../Components/RefBonusItem/RefBonusItem';

const RefBonus = () => {
    const { t } = useTranslation();

    const refBonusItems: RefBonusItemEntity[] = [
        { icon: walletBlue, title: t('my_p'), bgColor: '#007AFF0D', value: '2%' },
        { icon: caseOrange, title: t('my_r'), bgColor: '#FFA34E0D', value: '4%' },
        { icon: prize, title: t('my_b'), bgColor: '#2FF87F0D', value: '4%' },
    ];

    return (
        <div className="ref-bonus">
            <div>
                <img
                    className="il rfb"
                    src={ilIcon}
                    alt=""
                />

                <h1 dangerouslySetInnerHTML={{ __html: t('d_b') }}></h1>

                <div className="ref-bonus__items">
                    {refBonusItems.map((item) => (
                        <RefBonusItem
                            key={item.bgColor}
                            {...item}
                        />
                    ))}
                </div>
            </div>

            <div className="ref-bonus__description">
                <div className="ref-bonus__description--icon">
                    <div className="ref-bonus__description--icon--line"></div>
                    <img
                        src={infoIcon}
                        alt=""
                    />
                    <div className="ref-bonus__description--icon--line"></div>
                </div>
                <p>{t('ref_bonus_desc')}</p>
            </div>
        </div>
    );
};

export default RefBonus;
